import React from 'react'
import { useMediaQuery, useTheme, Box } from '@mui/material'
import { StatusWrapper, AccountSiteName, Actions } from '../../Components/TableActions'
import { useResponsiveTableContext, createExpandedRowComponent } from 'packages/ui/Table'
import CardActionButton from 'components/global/CardActions/CardActionButton'
import CardActionsButtonsGroup from 'components/global/CardActions/CardActionsButtonsGroup'

const ActionsWithExpand = ({ item, ctx }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const responsiveTableContext = useResponsiveTableContext()

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'flex-end',
      width: '100%',
      gap: 1
    }}>
      <Actions item={item} />
      {isMobile && responsiveTableContext && (
        <CardActionsButtonsGroup>
          <CardActionButton
            tooltiptitle={responsiveTableContext.isRowExpanded(item.id) ? ctx.t('documents.actions.collapse_details') : ctx.t('documents.actions.expand_details')}
            iconlabel={responsiveTableContext.isRowExpanded(item.id) ? 'chevron-up' : 'chevron-down'}
            onClick={(e) => {
              e.stopPropagation()
              responsiveTableContext.toggleRowExpansion(item.id)
            }}
          />
        </CardActionsButtonsGroup>
      )}
    </Box>
  )
}

export const ExpandedRowDetails = createExpandedRowComponent((item, t) => [
  {
    key: 'type',
    label: t('audin_document.table.reports.header.type'),
    value: item.type === 'audit'
      ? t('audin_document.report_type.audit')
      : t('audin_document.report_type.integration')
  },
  {
    key: 'account',
    label: t('audin_document.table.reports.header.account'),
    value: item.wifirstsite?.organism?.name || '-'
  },
  {
    key: 'updated_at',
    label: t('audin_document.table.reports.header.updated_at'),
    value: item.updated_at || '-'
  },
  {
    key: 'format',
    label: t('audin_document.table.reports.header.form'),
    value: 'WEB'
  }
])

const COLUMNS_CONFIG_AUDIN = [
  {
    name: 'step',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.status')
    },
    value: (item) => <StatusWrapper step={item.step} uppercase={false} isCenterDocument={false}/>,
    sortBy: 'step',
    sortable: true,
    style: { width: '5%' },
    priority: 1
  },
  {
    name: 'label',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.label')
    },
    value: item => item.name,
    sortBy: 'name.raw',
    sortable: true,
    style: { width: '15%' },
    priority: 1
  },
  {
    name: 'type',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.type')
    },
    value: (item, ctx) => {
      if (item.type === 'audit') {
        return ctx.t('audin_document.report_type.audit')
      } else if (item.type === 'integration') {
        return ctx.t('audin_document.report_type.integration')
      } else if (item.type === 'technicalvisit') {
        return ctx.t('audin_document.report_type.technical_visit')
      } else if (item.type === 'revisedtechnicalvisit') {
        return ctx.t('audin_document.report_type.revised_technical_visit')
      }
      return ''
    },
    sortBy: 'type',
    sortable: true,
    style: { width: '15%' },
    priority: 3
  },
  {
    name: 'account',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.account')
    },
    value: item => <AccountSiteName item={item} isAccount={true} />,
    sortBy: 'wifirstsite.organism.name.raw',
    sortable: true,
    style: { width: '15%' },
    priority: 4
  },
  {
    name: 'site_name',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.site_name')
    },
    value: (item, ctx) => (
      <AccountSiteName 
        item={item} 
        isAccount={false} 
        onClick={() => ctx.onSiteClick && ctx.onSiteClick(item)}
      />
    ),
    sortBy: 'wifirstsite.name.raw',
    sortable: true,
    style: { width: '15%' },
    priority: 1
  },
  {
    name: 'created_at',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.created_at')
    },
    value: item => item.created_at,
    sortBy: 'created_at',
    sortable: true,
    style: { width: '7%' },
    priority: 2
  },
  {
    name: 'updated_at',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.updated_at')
    },
    value: item => item.updated_at,
    sortBy: 'updated_at',
    sortable: true,
    style: { width: '8%' },
    priority: 4
  },
  {
    name: 'format',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.form')
    },
    value: () => 'WEB',
    sortBy: 'format',
    sortable: true,
    style: { width: '5%' },
    priority: 3
  },
  {
    name: 'actions',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.actions')
    },
    value: (item, ctx) => <ActionsWithExpand item={item} ctx={ctx} />,
    style: { width: '10%' },
    priority: 1
  }
]

export default COLUMNS_CONFIG_AUDIN